// Description: validation for Postal Code
// https://stackoverflow.com/questions/1146202/canadian-postal-code-validation
//
// cannot contain D, F, I, O, Q, U, cannot start with W, Z
// case insentive

export default (phone) => {
  const re = /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/i;
  return re.test(String(phone)); // return true if match
};
